<template>
    <div class="jdjsad">
        <el-select v-model="sheng" value-key="id" placeholder="省份" @change="cksheng">
            <el-option
            v-for="item in shenglist"
            :key="item.id"
            :label="item.name"
            :value="item">
            </el-option>
        </el-select>
        <el-select v-model="shi" value-key="id" placeholder="城市" @change="ckshi">
            <el-option
            v-for="item in shilist"
            :key="item.id"
            :label="item.name"
            :value="item">
            </el-option>
        </el-select>
        <el-select v-model="qu" value-key="id" placeholder="区/县" @change="ckqu">
            <el-option
            v-for="item in qulist"
            :key="item.id"
            :label="item.name"
            :value="item">
            </el-option>
        </el-select>
        <el-select v-model="zhen" value-key="id" placeholder="街道/乡镇" @change="ckzhen">
            <el-option
            v-for="item in zhenlist"
            :key="item.id"
            :label="item.name"
            :value="item">
            </el-option>
        </el-select>
        <el-select v-if="inputName != '-4'" value-key="id" v-model="cun" placeholder="社区/村" @change="ckcun">
            <el-option
            v-for="item in cunlist"
            :key="item.id"
            :label="item.name"
            :value="item">
            </el-option>
        </el-select>
    </div>
</template>
<script>
export default {
    name:'week',
    props:{
       inputName:String
    },
    data(){
        return{
            userdata:{},
            region:[],
            sheng:'',
            shenglist:[],
            shi:'',
            shilist:[],
            qu:'',
            qulist:[],
            zhen:'',
            zhenlist:[],
            cun:'',
            cunlist:[],
            ageRegion:{}
        }
    },
    created(){
        let userdata = JSON.parse(sessionStorage.getItem('userdata'))
        this.$set(this,'userdata',userdata)
        // console.log(userdata,'登录人员信息')
        let region = JSON.parse(localStorage.getItem('region'))
        this.$set(this,'region',region)
        // console.log(region,'当前登录人员的地址')
        let newCity = [],newArea = [],newTown = [],newCun = []
        region.forEach(x => {
            if(x.level==0){
                this.shenglist.push(x)
                this.sheng = x
                if(userdata.level == 0){
                    this.addNext(x.id,0)
                    // this.ageRegion = x
                }
            }
            if(userdata.level >= 1){
                if(x.level==1){
                    newCity.push(x)
                }
            }
            if(userdata.level >= 2){
                if(x.level==2){
                    newArea.push(x)
                }
            }
            if(userdata.level >= 3){
                if(x.level==3){
                    newTown.push(x)
                }
            }
            if(userdata.level >= 4){
                if(x.level==4){
                    newCun.push(x)
                }
            }
        });
        // 市区回显
        if(newCity.length==1){
            this.shilist = newCity
            this.shi = newCity[0]
            if(userdata.level == 1){
                this.addNext(newCity[0].id,1)
                // this.ageRegion = newCity[0]
            }
        }else if(newCity.length==0){
            this.shilist = []
            this.shi = ''
            // this.ageRegion = this.shenglist[0]
        }else{
            this.shilist = newCity
            // this.ageRegion = this.shenglist[0]
        }
        // 区域回显
        if(newArea.length==1){
            this.qulist = newArea
            this.qu = newArea[0]
            if(userdata.level == 2){
                this.addNext(newArea[0].id,2)
                // this.ageRegion = newArea[0]
            }
        }else if(newArea.length==0){
            this.qulist = []
            this.qu = ''
            
            if(userdata.level == 2){
                // this.ageRegion = newCity[0]
            }
        }else{
            this.qulist = newArea
            this.qu = ''
            if(userdata.level == 2){
                // this.ageRegion = newCity[0]
            }
        }
        // 镇 回显
        if(newTown.length==1){
            this.zhenlist = newTown
            this.zhen = newTown[0]
            if(userdata.level == 3){
                this.addNext(newTown[0].id,3)
                // this.ageRegion = newTown[0]
            }
        }else if(newTown.length==0){
            this.zhenlist = []
            this.zhen = ''

            if(userdata.level == 3){
                // this.ageRegion = newArea[0]
            }
        }else{
            this.zhenlist = newTown
            this.zhen = ''
            if(userdata.level == 3){
                // this.ageRegion = newArea[0]
            }
        }
        // 社区/村回显
        if(newCun.length==1){
            this.cunlist = newCun
            this.cun = newCun[0]
        }else if(newCun.length==0){
            this.cunlist = []
            this.cun = ''
        }else{
            this.cunlist = newCun
            this.cun = ''
        }
        // this.$emit('childFn',this.ageRegion);
    },
    mounted(){
        // console.log(userdata)
        // let address = JSON.parse(localStorage.getItem('region'))
        // this.options = address
    },
    methods:{
        // 当前选中只有一级的时候自动获取下一级地区
        addNext(regId,stat){
            this.$axios.post(`/api-r/area/getSubordinateAreaList`,this.$qs.stringify({areasId:regId}),{headers:{accessToken:this.userdata.token}})
            .then(res=>{
                if(res.data.success){
                    if(stat == 0){
                        this.$set(this,'shilist',res.data.areaListInfoList)
                    }else if(stat == 1){
                        this.$set(this,'qulist',res.data.areaListInfoList)
                    }else if(stat == 2){
                        this.$set(this,'zhenlist',res.data.areaListInfoList)
                    }else if(stat == 3){
                        this.$set(this,'cunlist',res.data.areaListInfoList)
                    }
                }
            })
        },
        cksheng(val){
            // 重新选择了省编辑
            sessionStorage.setItem('sabStat',0)
            sessionStorage.setItem('xgStat',1)
            if(this.userdata.level==0){
                this.$axios.post(`/api-r/area/getSubordinateAreaList`,this.$qs.stringify({areasId:val.id}),{headers:{accessToken:this.userdata.token}})
                .then(res=>{
                    if(res.data.success){
                        this.$set(this,'shilist',res.data.areaListInfoList)
                    }
                })
                this.$emit('childFn',val);
            }else{
                this.region.forEach(x=>{
                    if(x.level==1){
                        this.shilist.push(x)
                    }
                })
                this.$emit('childFn','');
            }
            this.$set(this,'shi','')
            this.$set(this,'qu','')
            this.$set(this,'zhen','')
            this.$set(this,'cun','')
        },
        ckshi(val){
            sessionStorage.setItem('xgStat',1)
            sessionStorage.setItem('sabStat',0)
            if(this.userdata.level<=1){
                this.$axios.post(`/api-r/area/getSubordinateAreaList`,this.$qs.stringify({areasId:val.id}),{headers:{accessToken:this.userdata.token}})
                .then(res=>{
                    if(res.data.success){
                        this.$set(this,'qulist',res.data.areaListInfoList)
                    }
                })
                this.$emit('childFn',val);
            }else{
                this.region.forEach(x=>{
                    if(x.level==2){
                        this.qulist.push(x)
                    }
                })
                this.$emit('childFn','');
            }
            this.$set(this,'qu','')
            this.$set(this,'zhen','')
            this.$set(this,'cun','')
        },
        ckqu(val){
            sessionStorage.setItem('xgStat',1)
            sessionStorage.setItem('sabStat',0)
            if(this.userdata.level<=2){
                this.$axios.post(`/api-r/area/getSubordinateAreaList`,this.$qs.stringify({areasId:val.id}),{headers:{accessToken:this.userdata.token}})
                .then(res=>{
                    if(res.data.success){
                        this.$set(this,'zhenlist',res.data.areaListInfoList)
                    }
                })
                this.$emit('childFn',val);
            }else{
                this.region.forEach(x=>{
                    if(x.level==3){
                        this.zhenlist.push(x)
                    }
                })
                this.$emit('childFn','');
            }
            this.$set(this,'zhen','')
            this.$set(this,'cun','')
        },
        ckzhen(val){
            sessionStorage.setItem('xgStat',1)
            if(this.userdata.level<=3){
                this.$axios.post(`/api-r/area/getSubordinateAreaList`,this.$qs.stringify({areasId:val.id}),{headers:{accessToken:this.userdata.token}})
                .then(res=>{
                    if(res.data.success){
                        this.$set(this,'cunlist',res.data.areaListInfoList)
                    }
                })
                this.$emit('childFn',val);
            }else{
                this.region.forEach(x=>{
                    if(x.level==3){
                        this.cunlist.push(x)
                    }
                })
                this.$emit('childFn','');
            }
            // 告诉父组件这个食安办必须要添加到街道
            if(this.inputName == '-4'){
                sessionStorage.setItem('sabStat',1)
            }else{
                sessionStorage.setItem('sabStat',0)
            }
            this.$set(this,'cun','')
        },
        ckcun(val){
            this.$emit('childFn',val);
            sessionStorage.setItem('xgStat',0)
        },
        // translateDataToTree(data) {
        //     let parents = data.filter(value => value.parentId == 'undefined' || value.parentId == 0)
        //     let childrens = data.filter(value => value.parentId !== 'undefined' && value.parentId != 0)
        //     let translator = (parents, childrens) => {
        //         parents.forEach((parent) => {
        //             childrens.forEach((current, index) => {
        //                 if (current.parentId === parent.id) {
        //                     let temp = JSON.parse(JSON.stringify(childrens))
        //                     temp.splice(index, 1)
        //                     translator([current], temp)
        //                     typeof parent.children !== 'undefined' ? parent.children.push(current) : parent.children = [current]
        //                 }
        //             })                            
        //         }
        //         )
        //     }
        //     translator(parents, childrens)
        //     return parents
        // }
    }
}
</script>
<style>
    .jdjsad{
        /* margin-left: 14px; */
        /* display: flex; */
        /* flex-wrap: wrap; */
        display: contents;
    }
    .jdjsad .el-select{
        margin-right: 16px;
        width: 216px !important;
    }
    .jdjsad .el-input__inner{
        /* margin: 10px 0; */
    }
</style>